// Remove o token de convite/reset (?token=...) de tudo que vai para o Sentry.
const FILTERED = '[Filtered]';
const TOKEN_RE = /((?:^|[?&#])token=)[^&#\s"']*/gi;

export function scrubUrl<T>(u: T): T {
  if (typeof u !== 'string') return u;
  return u.replace(TOKEN_RE, `$1${FILTERED}`) as unknown as T;
}

/** Varre recursivamente strings e chaves `token` de um objeto (muta e retorna). */
export function scrubDeep<T>(value: T, depth = 0): T {
  if (typeof value === 'string') return scrubUrl(value);
  if (!value || typeof value !== 'object' || depth > 12) return value;
  if (Array.isArray(value)) {
    value.forEach((v, i) => {
      value[i] = scrubDeep(v, depth + 1);
    });
    return value;
  }
  const obj = value as Record<string, unknown>;
  for (const key of Object.keys(obj)) {
    obj[key] =
      key.toLowerCase() === 'token' && typeof obj[key] === 'string'
        ? FILTERED
        : scrubDeep(obj[key], depth + 1);
  }
  return value;
}

export const scrubEvent = <T>(event: T): T => scrubDeep(event);
export const scrubBreadcrumb = <T>(breadcrumb: T): T => scrubDeep(breadcrumb);

/** Eventos custom de replay (type 5). O rrweb Meta (type 4, href) não passa por este callback: rotas com segredo na URL não gravam replay (sentry-config). */
export function scrubReplayEvent<T extends { type?: number }>(event: T): T {
  return event.type === 5 ? scrubDeep(event) : event;
}
